<template>
  <div class="specialAreaOfQuality container" ref="container">
    <div class="bannerBox">
      <van-image class="banner" :src="youpPath + bannerImg" />
      <div class="modify">
        <div class="subCon"></div>
      </div>
    </div>
    <div class="content">
      <div class="tipBox">
        <div class="tipItem">
          <span class="iconfont icon-dui-copy"></span>
          <span>淘宝精选好物</span>
        </div>
        <div class="tipItem">
          <span class="iconfont icon-dui-copy"></span>
          <span>平台补贴</span>
        </div>
        <div class="tipItem">
          <span class="iconfont icon-dui-copy"></span>
          <span>大额优惠券</span>
        </div>
      </div>
      <van-list v-model="loading" :finished="finished" :error.sync="error" error-text="请求失败，点击重新加载" finished-text="没有更多了" :immediate-check="false" @load="onLoad">
        <template #finished>
          <segement-Line line-text="没有更多商品啦"> </segement-Line>
        </template>
        <good-item v-for="(item, index) in list" :key="index" :goodsInfo="item" @entotTLJDetailPage="entotTLJDetailPage"></good-item>
      </van-list>
    </div>
  </div>
</template>

<script>
import { IMG_BASE_URL } from '@/config'
import { GetTLJProductList } from '@/api/souhuo'
import { List } from 'vant'
import GoodItem from './components/GoodItem'
import SegementLine from '@/components/puppetComponent/SegementLine'
export default {
  name: 'specialAreaOfQuality',
  components: {
    'van-list': List,
    GoodItem,
    SegementLine
  },
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      list: [], // 淘礼金商品列表
      total: 0,
      error: false,
      youpPath: IMG_BASE_URL,
      bannerImg: '/upaiyun/Sys/20211028/4887635995322806893.png',
      container: null
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.container = this.$refs.container
    })
  },

  methods: {
    onLoad() {
      this.loading = true
      GetTLJProductList({ page: this.page })
        .then((res) => {
          let data = res.Data
          this.total = data.total
          this.list = [...this.list, ...data.rows]
          this.loading = false
          this.page++
          if (this.list.length >= this.total) {
            this.finished = true
          }
        })
        .catch(() => {
          this.error = true
        })
    },
    reFetchPage() {
      this.loading = false
      this.finished = false
      this.page = 1
      this.list = [] // 淘礼金商品列表
      this.total = 0
      this.error = false
      this.onLoad()
    },
    entotTLJDetailPage(NumID) {
      this.$router.push({
        name: 'cashGiftGoodsDetail',
        query: {
          id: NumID
        }
      })
    }
  },

  //记录离开时的位置
  beforeRouteLeave(to, from, next) {
    //保存滚动条元素div的scrollTop值
    this.scrollY = this.$refs.container.scrollTop
    next()
  },

  // 为div元素重新设置保存的scrollTop值
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$nextTick(function() {
        let routeNames = ['cashGiftGoodsDetail']
        if (routeNames.indexOf(from.name) !== -1 && vm.container) {
          vm.$refs.container.scrollTop = vm.scrollY
        } else {
          vm.$nextTick(() => {
            vm.reFetchPage()
          })
        }
      })
    })
  }
}
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.specialAreaOfQuality {
  display: flex;
  align-items: center;
  flex-direction: column;
  .bannerBox {
    position: relative;
    overflow: hidden;
    flex-shrink: 0;
    .banner {
      width: 100%;
      display: block;
    }
    .modify {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: vw(1200);
      height: vw(900);
      transform: translateX(-50%);
      background-color: #fff;
      .subCon {
        width: 100%;
        height: 100%;
        background: url('http://youp-read.leqilucky.com/upaiyun/Sys/20211028/4887635995322806893.png') no-repeat;
        background-size: vw(375) auto;
        background-position-y: bottom;
        background-position-x: center;
        border-radius: 80%;
      }
    }
  }

  .content {
    width: 100%;
    flex: 1;
    background-color: #fff;
    /deep/ .segement-line .line-tip {
      background: #fff;
    }
    .tipBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: vw(12);
      font-weight: 400;
      color: #666666;
      height: vw(40);
      border-bottom: 1px solid rgba(242, 242, 242, 0.8);
      padding: 0 2%;
      .tipItem {
        display: flex;
        align-items: center;
        .iconfont {
          color: #e6ba49;
          margin-right: vw(4);
        }
      }
    }
  }
}
</style>
